<app-page-header
  title="Mitarbeiter verwalten"
  subtitle="Alle Mitarbeiter Ihres Unternehmens im Überblick"
  icon="badge"
  variant="gradient">
</app-page-header>

<div class="apple-container">
  <div class="apple-manage-employees-table-card apple-card">
    <table class="apple-manage-employees-table">
      <thead>
        <tr class="apple-table-header-row">
          <th class="global-table-header-cell">Name</th>
          <th class="global-table-header-cell">E-Mail</th>
          <th class="global-table-header-cell">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let employee of employees$ | async" class="apple-table-row">
          <td class="global-table-cell">{{ employee.userDetails?.firstName }} {{ employee.userDetails?.lastName }}</td>
          <td class="global-table-cell">{{ employee.userDetails?.email }}</td>
          <td class="global-table-cell">
            <span [class]="employee.isActive ? 'status-active' : 'status-inactive'">
              {{ employee.isActive ? 'Aktiv' : 'Inaktiv' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="(employees$ | async)?.length === 0" class="empty-state">
      Keine Mitarbeiter gefunden.
    </div>
  </div>
</div>
